import { IModuleUserCategory } from 'app/library/module/interfaces/module-user-category.interface';
import { ModuleUserCategory } from '../enums/module-user-category.enum';

// @dynamic
export class ModuleUserCategoryStatus {
    static all: IModuleUserCategory[] = [
        {
            name: ModuleUserCategory.UPCOMING,
            translationLabel: 'MODULE_USER.CATEGORY.UPCOMING',
            color: '#FFE604',
        },
        {
            name: ModuleUserCategory.ENDED,
            translationLabel: 'MODULE_USER.CATEGORY.COMPLETED',
            color: '#B1D42D',
        },
        {
            name: ModuleUserCategory.RUNNING,
            translationLabel: 'MODULE_USER.CATEGORY.RUNNING',
            color: '#3774EF',
        },
    ];
}
